module.exports = __webpack_public_path__ + "static/media/project13.40fff785.jpg";